const ProductSpecifications = ({ product }) => {
  const specs = {
    BRAND: product.category, // hardcoded or from product.brand
    TASTE: product.taste || "N/A",
    "NICOTINE LEVEL": product.nicotineLevel || "N/A",
    // QUANTITY: product.packs?.length
    //   ? `${product.packs.pack.code} Packs`
    //   : "N/A",
    Weight: product.weight || "N/A",
    Dimensions: product.dimensions || "N/A",
  }

  return (
    <div className="w-full mt-6">
      <h2 className="text-lg font-semibold mb-4">Specifications</h2>
      <div className="border rounded-md overflow-hidden">
        <table className="w-full border-collapse">
          <tbody>
            {Object.entries(specs).map(([key, value], index) => (
              <tr
                key={index}
                className="border-b last:border-b-0 odd:bg-gray-50 even:bg-white"
              >
                <td className="px-4 py-3 text-sm font-medium text-gray-600 w-1/3">
                  {key}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900">{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default ProductSpecifications
